import * as _4 from 'lodash4';
class FormFailureController {
  private errorMessage: string;
  constructor(private $state: ng.ui.IStateService) {}
  $onInit() {
    if (!_4.isEmpty(this.$state.params.explicitErrorReason)) {
      this.errorMessage = this.$state.params.explicitErrorReason;
    } else if (!_4.isEmpty(this.$state.params.eaberror)) {
      this.errorMessage = this.$state.params.eaberror;
    } else {
      this.errorMessage = _4.get(
        this.$state.current,
        'data.defaultErrorMessage',
        `Unable to log you in. Please try again.`
      );
    }
  }
}
angular.module('capability-ng-authentication').controller('FormFailureController', FormFailureController);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-authentication/src/views/form_failure/form_failure.ts